import { Component } from '@angular/core';

@Component({
  template: '<h2>You do not have access to view this</h2>'
})
export class NotAuthorizedComponent {}
